// src/layouts/PrivateLayout.jsx
import React from 'react';
import Header from '../components/header';
import { Outlet } from 'react-router-dom';

const PrivateLayout = () => {
    return (
        <div>
            <Header />
            <main className="p-4 pt-20">
                <Outlet />
            </main>
        </div>
    );
};

export default PrivateLayout;